import React from 'react';
import { Input, Row, Col } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class FieldMapEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e, item) {
        item.value = e.target.value;
        this.props.source.value = [...this.props.source.value];
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {
        let source = this.props.source;
        return (
            (source.value || []).map((item, index) => {
                return <Row key={index}>
                    <Col span={8}>
                        <Input value={item.field} readOnly />
                    </Col>
                    <Col span={1}></Col>
                    <Col span={15}>
                        <Input value={item.value} onChange={e => this.onChange(e, item)} placeholder={this.props.source.placeholder || ""} />
                    </Col>
                </Row>
            })
        );
    }
}

PropertyGridUtils.register("fieldMap", (source, propertyGrid) => <FieldMapEditor source={source} propertyGrid={propertyGrid} />);